var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "toolbar-container" },
    [
      _c(
        "div",
        { staticClass: "left-toolbar" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "text",
                disabled: _vm.undoDisabled,
                title: "撤销",
              },
              on: { click: _vm.undoHistory },
            },
            [_c("span", { staticClass: "iconfont iconicon_back" })]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "text",
                disabled: _vm.redoDisabled,
                title: "重做",
              },
              on: { click: _vm.redoHistory },
            },
            [_c("span", { staticClass: "iconfont icona-icon_nextstep" })]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "right-toolbar" }, [
        _c(
          "div",
          { staticClass: "right-toolbar-con" },
          [
            _c(
              "el-button",
              { staticClass: "view-btn", on: { click: _vm.previewForm } },
              [_c("i", { staticClass: "el-icon-view" }), _vm._v("预览")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              { staticClass: "clear-btn", on: { click: _vm.clearFormWidget } },
              [_c("i", { staticClass: "el-icon-delete" }), _vm._v("清空")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.exportJson } },
              [
                _c("i", { staticClass: "el-icon-collection" }),
                _vm._v("\n        保存"),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.$slots, function (idx, slotName) {
              return [_vm._t(slotName)]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.showPreviewDialogFlag
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialog-drag", rawName: "v-dialog-drag" }],
              staticClass: "small-padding-dialog",
              attrs: {
                title: "预览",
                visible: _vm.showPreviewDialogFlag,
                "show-close": true,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                center: "",
                "destroy-on-close": true,
                "append-to-body": true,
                width: "75%",
                fullscreen: false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showPreviewDialogFlag = $event
                },
              },
            },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "form-render-wrapper",
                    class: [
                      _vm.layoutType === "H5"
                        ? "h5-layout"
                        : _vm.layoutType === "Pad"
                        ? "pad-layout"
                        : "",
                    ],
                  },
                  [
                    _c("VFormRender", {
                      ref: "preForm",
                      attrs: {
                        "form-json": _vm.formJson,
                        "form-data": _vm.testFormData,
                        "preview-state": true,
                        "option-data": _vm.testOptionData,
                        "global-dsv": _vm.designerDsv,
                      },
                      on: {
                        appendButtonClick: _vm.testOnAppendButtonClick,
                        buttonClick: _vm.testOnButtonClick,
                        formChange: _vm.handleFormChange,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.getFormData },
                    },
                    [_vm._v("获取数据")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.resetForm },
                    },
                    [_vm._v("重置表单")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.setFormDisabled },
                    },
                    [_vm._v("禁用编辑")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.setFormEnabled },
                    },
                    [_vm._v("恢复编辑")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onlyReadMode },
                    },
                    [_vm._v("只读查看")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "" },
                      on: {
                        click: function ($event) {
                          _vm.showPreviewDialogFlag = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showExportJsonDialogFlag
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialog-drag", rawName: "v-dialog-drag" }],
              staticClass: "small-padding-dialog",
              attrs: {
                title: "导出JSON",
                visible: _vm.showExportJsonDialogFlag,
                "show-close": true,
                center: "",
                "append-to-body": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "destroy-on-close": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showExportJsonDialogFlag = $event
                },
              },
            },
            [
              _c("code-editor", {
                attrs: { mode: "json", readonly: true },
                model: {
                  value: _vm.jsonContent,
                  callback: function ($$v) {
                    _vm.jsonContent = $$v
                  },
                  expression: "jsonContent",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "copy-json-btn",
                      attrs: {
                        type: "primary",
                        "data-clipboard-text": _vm.jsonRawContent,
                      },
                      on: { click: _vm.copyFormJson },
                    },
                    [_vm._v("\n        复制JSON")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "" },
                      on: {
                        click: function ($event) {
                          _vm.showExportJsonDialogFlag = false
                        },
                      },
                    },
                    [_vm._v(" 关闭")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showFormDataDialogFlag
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialog-drag", rawName: "v-dialog-drag" }],
              staticClass: "dialog-title-light-bg",
              attrs: {
                title: "表单数据",
                visible: _vm.showFormDataDialogFlag,
                "show-close": true,
                center: "",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "destroy-on-close": true,
                "append-to-body": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showFormDataDialogFlag = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticStyle: { border: "1px solid #dcdfe6" } },
                [
                  _c("code-editor", {
                    attrs: { mode: "json", readonly: true },
                    model: {
                      value: _vm.formCopyJson,
                      callback: function ($$v) {
                        _vm.formCopyJson = $$v
                      },
                      expression: "formCopyJson",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "copy-form-data-json-btn",
                      attrs: {
                        type: "primary",
                        "data-clipboard-text": _vm.formDataRawJson,
                      },
                      on: { click: _vm.copyFormDataJson },
                    },
                    [_vm._v("\n        复制JSON")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "" },
                      on: {
                        click: function ($event) {
                          _vm.showFormDataDialogFlag = false
                        },
                      },
                    },
                    [_vm._v(" 关闭")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }